import { render, staticRenderFns } from "./OrderingMenuHomepage.vue?vue&type=template&id=46ef78b4&scoped=true"
import script from "./OrderingMenuHomepage.vue?vue&type=script&lang=js"
export * from "./OrderingMenuHomepage.vue?vue&type=script&lang=js"
import style0 from "./OrderingMenuHomepage.vue?vue&type=style&index=0&id=46ef78b4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef78b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ef78b4')) {
      api.createRecord('46ef78b4', component.options)
    } else {
      api.reload('46ef78b4', component.options)
    }
    module.hot.accept("./OrderingMenuHomepage.vue?vue&type=template&id=46ef78b4&scoped=true", function () {
      api.rerender('46ef78b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/PreviewArea/OrderingMenuHomepage.vue"
export default component.exports